"use strict";

var _defineProperty = require("/codebuild/output/src1656618240/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var genRadiusStyle = function genRadiusStyle(token) {
  var _componentCls;

  var componentCls = token.componentCls,
      tableRadius = token.tableRadius;
  return _defineProperty({}, "".concat(componentCls, "-wrapper"), _defineProperty({}, componentCls, (_componentCls = {}, _defineProperty(_componentCls, "".concat(componentCls, "-title, ").concat(componentCls, "-header"), {
    borderRadius: "".concat(tableRadius, "px ").concat(tableRadius, "px 0 0")
  }), _defineProperty(_componentCls, "".concat(componentCls, "-title + ").concat(componentCls, "-container"), {
    borderStartStartRadius: 0,
    borderStartEndRadius: 0,
    table: {
      borderRadius: 0,
      '> thead > tr:first-child': {
        'th:first-child': {
          borderRadius: 0
        },
        'th:last-child': {
          borderRadius: 0
        }
      }
    }
  }), _defineProperty(_componentCls, '&-container', {
    borderStartStartRadius: tableRadius,
    borderStartEndRadius: tableRadius,
    'table > thead > tr:first-child': {
      '> *:first-child': {
        borderStartStartRadius: tableRadius
      },
      '> *:last-child': {
        borderStartEndRadius: tableRadius
      }
    }
  }), _defineProperty(_componentCls, '&-footer', {
    borderRadius: "0 0 ".concat(tableRadius, "px ").concat(tableRadius, "px")
  }), _componentCls)));
};

var _default = genRadiusStyle;
exports.default = _default;